export const FUNDS_ORIGINS = {
    BENEFITS: 'benefits',
    PRIVATE_LOANS: 'privateLoans',
    FINANCIAL_INVESTMENTS: 'financialInvestments',
    REAL_STATE_INVESTMENTS: 'realStateInvestments',
};

export const FUNDS_ORIGINS_USER_PROFILE_KEYS = {
    [FUNDS_ORIGINS.BENEFITS]: 'fundsOrigin_benefits',
    [FUNDS_ORIGINS.PRIVATE_LOANS]: 'fundsOrigin_privateLoans',
    [FUNDS_ORIGINS.FINANCIAL_INVESTMENTS]: 'fundsOrigin_financialInvestments',
    [FUNDS_ORIGINS.REAL_STATE_INVESTMENTS]: 'fundsOrigin_realStateInvestments',
};
